import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AppLayout from "@/components/AppLayout";
import { PlayerProvider } from "@/context/PlayerContext";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Collections from "@/pages/Collections";
import Saved from "@/pages/Saved";
import ItemDetail from "@/pages/ItemDetail";
import SeriesDetail from "@/pages/SeriesDetail";
import About from "@/pages/About";
import DisciplineDetail from "@/pages/DisciplineDetail";

export default function App() {
  return (
    <BrowserRouter>
      <PlayerProvider>
        <AppLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/saved" element={<Saved />} />
            <Route path="/item/:id" element={<ItemDetail />} />
            <Route path="/series/:name" element={<SeriesDetail />} />
            <Route path="/discipline/:slug" element={<DisciplineDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </AppLayout>
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#161009",
              color: "#FDFCFB",
              border: "1px solid rgba(227,194,130,0.35)",
              fontFamily: "Inter, sans-serif",
            },
          }}
        />
      </PlayerProvider>
    </BrowserRouter>
  );
}
